// extracted by mini-css-extract-plugin
export default {"unauthorizedDiv":"gK1cW7NzrO6QHWZ3SLGA"};